import { render, staticRenderFns } from "./PublishToPlatformModal.vue?vue&type=template&id=90db4f7a&scoped=true"
import script from "./PublishToPlatformModal.vue?vue&type=script&lang=js"
export * from "./PublishToPlatformModal.vue?vue&type=script&lang=js"
import style0 from "./PublishToPlatformModal.vue?vue&type=style&index=0&id=90db4f7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90db4f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90db4f7a')) {
      api.createRecord('90db4f7a', component.options)
    } else {
      api.reload('90db4f7a', component.options)
    }
    module.hot.accept("./PublishToPlatformModal.vue?vue&type=template&id=90db4f7a&scoped=true", function () {
      api.rerender('90db4f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/PublishToPlatformModal.vue"
export default component.exports